import create from 'utils/command'
import {associate} from 'utils/functions' 
import immutableUpdate from 'external/immutability-helper'
import {isAfter, parseDate} from 'external/date-fns'
import {orderBy} from 'external/lodash'

const hooks =  [
  {paths: ['refreshHomeworks', 'props/params/section', 'props/query/orderBy', 'props/query/page'], resolves: [fetchHomeworks]},
  {paths: ['props/params/homeworkId', 'status', 'refreshHomework'], resolves: [fetchHomework]}
]

export {hooks as default}

export async function fetchStatus ({state, update}) {
  if (state.status) return
  const status = await create('homework', 'getHomeworkStatus')()
  const statusMap = associate('id', 'name')(status)
  update({$shallow: {status, statusMap}})
}


export async function fetchHomeworks({state, update}, {path}) {
  const {props: {query, params}} = state
  const {groupId: clique, section, pageName, homeworkId} = params
  if (pageName != 'my-courses' || section != 'homework' || !clique || homeworkId != undefined) return
  if (!path || !path.startsWith('props/query')) update({homeworks: {$set: undefined}}) // Clear homeworks unless is updating a query parameter
  const homeworks = await create('student', 'searchHomeworks')({...query, clique})
  update({homeworks: {$set: homeworks}})
}

export async function fetchHomework ({state, update}, {path}) {
  const {props: {params}, statusMap} = state
  const {pageName, homeworkId} = params
  if (pageName != 'my-courses' || !homeworkId || !state.status) return
  update({homeworkLoaded: {$set: false}, homework: {$set: {}}})
  const [item] = await create('homework','getStudentHomework')({homeworkId})
  const status = item.status.map(status => ({...status, stamp: parseDate(status.created).valueOf()}))
  const sortedStatus = orderBy(status, ['stamp'])
  const latestStatus = sortedStatus[status.length-1]
  const statusName = statusMap[latestStatus.status]
  const expired = isAfter(new Date(), item.endDate)
  const available = !expired && ['returned', 'assigned'].indexOf(statusName) >= 0
  const homework = immutableUpdate(item, {homework:{$shallow:{latestStatus, statusName, available}}})
  update({homeworkLoaded: {$set: true}, homework: {$set: homework}})
}
